import { Row, Col, Button, Spin } from 'antd';
import type { StoredTeamRole } from '../../../hooks/types';
import { teamRolesQueryName } from '../../../hooks/useQueryTeamRoles';
import useUpdateTeamRole from '../../../hooks/useUpdateTeamRole';
import { successMessage } from '../../../lib/utils/messages';
import { useNotify } from '../../../hooks/useNotify';
import { onApolloError } from '../../../lib/graphql/helpers';

type RetiredTeamRoleFormProps = {
  readonly role: StoredTeamRole;
};

/**
 * @returns A form for showing and reactivating retired team roles.
 */
const RetiredTeamRoleForm = (props: RetiredTeamRoleFormProps) => {
  const { notify } = useNotify();

  const [updateRole, { loading: updatingRole }] = useUpdateTeamRole(
    onApolloError(notify.error)
  );

  const roleName = props.role.name;

  const roleGroup = props.role.role_group;

  return (
    <Row key={props.role.id}>
      <Col flex={'auto'} style={{ border: 'inset' }}>
        <div style={{ padding: '4px 11px' }}>{roleName}</div>
      </Col>
      <Col flex={'120px'} style={{ border: 'inset' }}>
        <div style={{ padding: '4px' }}>{roleGroup}</div>
      </Col>
      <Col flex={'100px'}>
        <Button
          className="reactivate-btn"
          type="primary"
          style={{ float: 'right' }}
          onClick={() => {
            void updateRole({
              variables: {
                name: roleName,
                roleGroup,
                teamRoleId: props.role.id,
              },
              onCompleted: () => notify.success(successMessage.roleReactivated),
              onError: onApolloError(notify.error),
              // Note: We are choosing to currently refetch queries after update,
              // but a more efficient way to consider for the future may be to
              // directly update the cache after update.
              refetchQueries: [teamRolesQueryName],
            });
          }}
        >
          {updatingRole ? <Spin /> : 'Reactivate'}
        </Button>
      </Col>
    </Row>
  );
};

export default RetiredTeamRoleForm;
